var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 6.667a4.167 4.167 0 1 1 0-8.334 4.167 4.167 0 0 1 0 8.334M10 .75C5.834.75 2.275 3.342.833 7c1.442 3.658 5 6.25 9.167 6.25s7.725-2.592 9.167-6.25C17.725 3.342 14.167.75 10 .75"
  })));
};
export default SvgEye;